export default {
  // Common
  common: {
    welcome: 'Bienvenue',
    logout: 'Déconnexion',
    users: 'Utilisateurs',
    order: 'Commande',
    orders: 'Commandes',
    orderCount: '{{count}} commande(s)',
    comingSoon: 'Cette page sera développée prochainement',
    shipments: 'Expéditions',
    fleet: 'Flotte',
    languageUpdateError: 'Erreur lors de la mise à jour de la langue',
    save: 'Enregistrer',
    cancel: 'Annuler',
    delete: 'Supprimer',
    edit: 'Modifier',
    create: 'Créer',
    search: 'Rechercher',
    filter: 'Filtrer',
    reset: 'Réinitialiser',
    resetFilters: 'Réinitialiser',
    back: 'Retour',
    next: 'Suivant',
    contents: 'Sommaire',
    previous: 'Précédent',
    submit: 'Soumettre',
    confirm: 'Confirmer',
    close: 'Fermer',
    loading: 'Chargement...',
    error: 'Erreur',
    success: 'Succès',
    yes: 'Oui',
    no: 'Non',
    optional: 'Optionnel',
    required: 'Requis',
    dashboard: 'Tableau de bord',
    settings: 'Paramètres',
    view: 'Voir',
    download: 'Télécharger',
    actions: 'Actions',
    details: 'Détails',
    noData: 'Aucune donnée disponible',
    weight: 'Poids',
    weightUnit: 'kg',
    pallets: 'Palettes',
    price: 'Prix',
    priceUnit: '€',
    contact: 'Contact',
    phone: 'Téléphone',
    email: 'Email',
    address: 'Adresse',
    publish: 'Publier',
    follow: 'Suivre',
    accept: 'Accepter',
    decline: 'Refuser',
    accepting: 'Acceptation...',
    declining: 'Refus...',
    confirming: 'Confirmation...',
    all: 'Toutes',
    active: 'Actives',
    pending: 'En attente',
    completed: 'Terminées',
    pickup: 'Enlèvement',
    delivery: 'Livraison',
    route: 'Itinéraire',
    date: 'Date',
    time: 'Heure',
    status: 'Statut',
    cargo: 'Marchandise',
    trailer: 'Remorque',
    driver: 'Chauffeur',
    vehicle: 'Véhicule',
    company: 'Entreprise',
    name: 'Nom',
    firstName: 'Prénom',
    lastName: 'Nom',
    description: 'Description',
    instructions: 'Instructions',
    notes: 'Notes',
    message: 'Message',
    amount: 'Montant',
    shipper: 'Expéditeur',
    transporter: 'Transporteur',
    admin: 'Administrateur',
    companyLogo: 'Logo de l\'entreprise',
    profilePhoto: 'Photo de profil',
    changeImage: 'Changer l\'image',
    imageHint: 'JPG, PNG ou WebP. Max 2 Mo.',
    imageUploadSuccess: 'Image mise à jour avec succès',
    imageUploadError: 'Erreur lors du téléchargement de l\'image',
    imageTypeError: 'Format non supporté. Utilisez JPG, PNG ou WebP.',
    imageSizeError: 'Le fichier est trop volumineux. Maximum 2 Mo.',
  },

  // Auth
  auth: {
    welcomeTitle: 'Bienvenue sur Velox',
    form: {
      emailLabel: 'Email',
      emailPlaceholder: 'votre@email.com',
      passwordLabel: 'Mot de passe',
      passwordPlaceholder: '••••••••',
      languageLabel: 'Langue / Language *',
      phoneLabel: 'Téléphone',
      phonePlaceholder: '+33 6 12 34 56 78',
      firstNameLabel: 'Prénom',
      firstNamePlaceholder: 'Jean',
      lastNameLabel: 'Nom',
      lastNamePlaceholder: 'Dupont',
      companyNameLabel: 'Entreprise *',
      companyNamePlaceholder: 'Transport SA',
      companyTypeLabel: 'Type *',
      shipperOption: 'Expéditeur',
      transporterOption: 'Transporteur',
      confirmPasswordPlaceholder: '••••••••',
      forgotPasswordButton: 'Mot de passe oublié ?',
      signInButton: 'Se connecter',
      signingInButton: 'Connexion...',
    },
    login: {
      title: 'Connexion',
      subtitle: 'Connectez-vous ou créez un compte pour accéder à votre plateforme TMS',
      email: 'Email',
      password: 'Mot de passe',
      forgotPassword: 'Mot de passe oublié ?',
      submit: 'Se connecter',
      loading: 'Connexion...',
      success: 'Connexion réussie !',
      error: 'Identifiants incorrects',
      fillAllFields: 'Veuillez remplir tous les champs',
    },
    signup: {
      title: 'Inscription',
      email: 'Email',
      password: 'Mot de passe',
      confirmPassword: 'Confirmer',
      firstName: 'Prénom',
      lastName: 'Nom',
      phone: 'Téléphone',
      companyName: 'Entreprise',
      companyType: 'Type',
      shipper: 'Expéditeur',
      transporter: 'Transporteur',
      registrationNumber: 'ID Fiscal',
      registrationNumberPlaceholder: 'Ex: SIRET, TVA, NIF...',
      registrationNumberVerifying: 'Vérification en cours...',
      registrationNumberValid: '✓ Numéro valide',
      registrationNumberInvalid: '✗ Numéro invalide',
      registrationNumberExists: '⚠️ Cette entreprise est déjà enregistrée',
      countryCode: 'Pays',
      countryCodePlaceholder: 'FR',
      verified: 'Vérifié',
      alreadyExists: 'Déjà inscrit',
      verifying: 'Vérification...',
      iban: 'IBAN',
      ibanPlaceholder: 'FR76 1234 5678 9012 3456 7890 123',
      ibanRequired: 'L\'IBAN est obligatoire',
      foundedDate: 'Date d\'existence de la société',
      foundedDateRequired: 'La date d\'existence de la société est obligatoire',
      acceptTerms: 'J\'accepte les Conditions Générales d\'Utilisation et les Mentions Légales',
      acceptTermsPart1: 'J\'accepte les',
      termsLink: 'Conditions Générales d\'Utilisation',
      acceptTermsPart2: 'et les',
      privacyLink: 'Mentions Légales',
      termsRequired: 'Vous devez accepter les CGU et les Mentions Légales',
      submit: 'Créer un compte',
      loading: 'Création...',
      success: 'Compte créé avec succès !',
      error: 'Erreur lors de la création du compte',
      fillRequired: 'Veuillez remplir tous les champs obligatoires',
      passwordMismatch: 'Les mots de passe ne correspondent pas',
      passwordLength: 'Le mot de passe doit contenir au moins 6 caractères',
    },
    resetPassword: {
      title: 'Réinitialiser le mot de passe',
      subtitle: 'Entrez votre adresse email pour recevoir un lien de réinitialisation',
      email: 'Email',
      submit: 'Envoyer le lien',
      loading: 'Envoi en cours...',
      success: 'Email de réinitialisation envoyé !',
      error: "Erreur lors de l'envoi de l'email",
      backToLogin: 'Retour à la connexion',
      enterEmail: 'Veuillez entrer votre adresse email',
    },
    newPassword: {
      title: 'Nouveau mot de passe',
      subtitle: 'Choisissez un nouveau mot de passe sécurisé pour votre compte',
      password: 'Nouveau mot de passe',
      confirmPassword: 'Confirmer le mot de passe',
      placeholder: '••••••••',
      submit: 'Mettre à jour',
      loading: 'Mise à jour...',
      success: 'Mot de passe mis à jour avec succès',
      error: 'Erreur lors de la mise à jour du mot de passe',
      mismatch: 'Les mots de passe ne correspondent pas',
      tooShort: 'Le mot de passe doit contenir au moins 8 caractères',
      invalidToken: 'Ce lien de réinitialisation est invalide ou a expiré. Veuillez en demander un nouveau.',
      invalidTokenTitle: 'Lien invalide',
      backToLogin: 'Retour à la connexion',
    },
  },

  // Dashboard
  dashboard: {
    header: {
      shipper: 'Tableau de bord Expéditeur',
      transporter: 'Tableau de bord Transporteur',
      driver: 'Mes Missions',
      admin: "Panneau d'Administration",
    },
    stats: {
      totalOrders: 'Total commandes',
      activeOrders: 'Commandes actives',
      activeOrdersLabel: 'En cours',
      draftOrders: 'Brouillons',
      deliveredOrders: 'Livrées',
      pendingBids: 'Offres en attente',
      completedOrders: 'Commandes terminées',
      totalRevenue: 'Revenu total',
      activeDrivers: 'Chauffeurs actifs',
      availableDrivers: 'Chauffeurs disponibles',
      availableVehicles: 'Véhicules disponibles',
      ongoingMissions: 'Missions en cours',
      activeMissions: 'Missions actives',
      completedMissions: 'Missions terminées',
      assignedMissions: 'Assignées',
      totalTransporters: 'Total transporteurs',
      totalDrivers: 'Total chauffeurs',
      totalCommands: 'Total commandes',
      unpaidPayments: 'Paiements en attente',
    },
    emptyState: {
      noOrders: 'Aucune commande pour le moment',
      noOrdersInProgress: 'Aucune commande en cours pour le moment',
      noActiveMissions: 'Aucune mission active',
      noMissions: 'Aucune mission pour le moment',
      noAssignedMissions: 'Aucune mission assignée',
      noCompletedMissions: 'Aucune mission terminée',
      noBids: 'Aucune offre pour le moment',
      noInProgress: 'Aucune commande en cours',
      viewAllOrders: 'Voir toutes mes commandes',
    },
    pendingReservations: {
      title: 'Réservations en attente de confirmation',
      subtitle: '{{count}} transporteur{{s}} réservé vos commandes',
      subtitles: ' a',
      subtitlep: 's ont',
    },
    ordersInProgress: {
      title: 'Commandes en cours',
      subtitle: 'Vos commandes assignées et en transit',
    },
    activeMissions: {
      title: 'Missions actives',
      noMissions: 'Aucune mission active',
      consultMarketplace: 'Consultez le marketplace pour réserver des missions',
    },
    createOrder: 'Créer une commande',
  },

  // Orders
  orders: {
    title: 'Mes Commandes',
    noCoordinates: 'Coordonnées manquantes',
    print: {
      title: 'Bon de commande',
      button: 'Télécharger',
      printButton: 'Imprimer',
      generating: 'Génération en cours...',
      printing: 'Impression en cours...',
      success: 'Image générée',
      downloaded: 'Le bon de commande a été téléchargé avec succès',
      error: 'Erreur',
      elementNotFound: 'Impossible de trouver le contenu à capturer',
      generationFailed: 'Échec de la génération de l\'image',
      qrNotGenerated: 'QR Code non généré',
      pickupInfo: '📦 Informations d\'enlèvement',
      deliveryInfo: '🚚 Informations de livraison',
      cargoInfo: '📋 Marchandise',
      additionalInstructions: '⚠️ Instructions supplémentaires',
      notSpecified: 'Non spécifiée',
      title_field: 'Titre :',
      vehicleType: 'Type de véhicule :',
      volume: 'Volume :',
      platformDescription: 'VELOX - Plateforme de gestion logistique',
      generatedOn: 'Document généré le',
    },
    subtitle: 'Gérez toutes vos commandes par statut',
    create: 'Créer une commande',
    createNew: '+ Créer une commande',
    filterByStatus: 'Filtrer par statut',
    filterDescription: 'Sélectionnez un statut pour afficher les commandes correspondantes',
    selectStatus: 'Sélectionner un statut',
    orderNumber: 'Numéro de commande',
    statuses: {
      all: 'Toutes',
      draft: 'Brouillon',
      posted: 'Publiée',
      booked: 'Réservée',
      assigned: 'Assignée',
      in_transit: 'En transit',
      delivered: 'Livrée',
      cancelled: 'Annulée',
      drafts: 'Brouillons',
      posted_plural: 'Publiées',
      booked_plural: 'Réservées',
      assigned_plural: 'Assignées',
      in_transit_plural: 'En transit',
      delivered_plural: 'Livrées',
      cancelled_plural: 'Annulées',
    },
    statusDescriptions: {
      draft: 'Commande en cours de création',
      posted: 'Commande publiée sur le marketplace',
      booked: 'Demande acceptée, en attente d\'assignation chauffeur/véhicule',
      assigned: 'Chauffeur et véhicule assignés',
      in_transit: 'Commande en cours de livraison',
      delivered: 'Commande livrée avec succès',
      cancelled: 'Commande annulée',
    },
    status: {
      draft: 'Brouillon',
      posted: 'Publiée',
      booked: 'Réservée',
      assigned: 'Assignée',
      inTransit: 'En transit',
      delivered: 'Livrée',
      cancelled: 'Annulée',
    },
    statusLabels: {
      pending: 'En attente de confirmation',
      accepted: 'Acceptée',
      assigned: 'Assignée',
    },
    emptyStates: {
      all: 'Aucune commande pour le moment',
      draft: 'Aucun brouillon',
      posted: 'Aucune commande publiée',
      booked: 'Aucune commande réservée',
      assigned: 'Aucune commande assignée',
      in_transit: 'Aucune commande en transit',
      delivered: 'Aucune commande livrée',
      cancelled: 'Aucune commande annulée',
    },
    priceValidated: 'Prix validé',
    priceProposed: 'Prix proposé',
    myOffers: 'Mes offres',
    reservationPending: 'Réservation en attente',
    confirmation: 'Confirmation',
    refusal: 'Refus',
    yourPreviousOfferDeclined: 'Votre offre précédente a été refusée',
    declinedOn: 'Refusée le',
    yourPendingOffer: 'Votre offre en attente',
    proposedAmount: 'Montant proposé',
    submittedOn: 'Soumise le',
    bookFixedPrice: 'Réserver au prix fixe',
    makeOffer: 'Faire une offre',
    makeNewOffer: 'Faire une nouvelle offre',
    offerPendingResponse: 'Offre en attente de réponse',
    cancel: 'Annuler',
    confirmCancel: 'Voulez-vous vraiment annuler la mission {{orderNumber}} ?',
    cancelSuccess: 'Mission annulée avec succès',
    cancelError: "Erreur lors de l'annulation",
    transporter: 'Transporteur',
    statusLabel: 'Statut',
    pickupDate: 'Date de départ',
    pickupLocation: 'Lieu d\'enlèvement',
    deliveryDate: 'Date de livraison',
    deliveryLocation: 'Lieu de livraison',
    weight: 'Poids',
    price: 'Prix',
    trailerType: 'Type de remorque',
    form: {
      title: 'Créer une commande',
      subtitle: 'Remplissez les informations de votre transport',
      priceRequired: 'Prix proposé requis pour publier la commande',
    },
    card: {
      order: 'Commande',
      validatedPrice: 'Prix validé',
      proposedPrice: 'Prix proposé',
      weight: 'Poids',
      pallets: 'palettes',
      boxes: 'caisses',
      euroPallets: 'euro-palettes',
      publish: 'Publier',
      myOffers: 'Mes offres',
      track: 'Suivre',
      details: 'Détails',
    },
    details: {
      title: 'Détails complets de la commande',
      proposedPrice: 'Prix proposé',
      cargo: 'Marchandise',
      cargoTitle: 'Titre :',
      cargoDescription: 'Description :',
      cargoImage: 'Photo de la marchandise',
      startImages: 'Photos au départ',
      deliveryImages: 'Photos à la livraison',
      weight: 'Poids :',
      pallets: 'Palettes :',
      boxes: 'Caisses :',
      euroPallets: 'Euro-palettes :',
      volume: 'Volume :',
      type: 'Type :',
      route: 'Itinéraire',
      pickup: 'Enlèvement :',
      delivery: 'Livraison :',
      transporterInfo: 'Informations du transporteur',
      company: 'Entreprise',
      assignedDriver: 'Chauffeur assigné',
      vehicle: 'Véhicule',
      plateNumber: 'Plaque',
      licenseNumber: 'Permis',
      trailerType: 'Type de remorque',
      specialInstructions: 'Instructions spéciales',
      visibleMarketplace: '✓ Visible sur le marketplace',
      edit: 'Modifier',
      print: 'Imprimer',
      delete: 'Supprimer',
      close: 'Fermer',
      confirmDelete: 'Confirmer la suppression',
      confirmDeleteText: 'Êtes-vous sûr de vouloir supprimer la commande {{orderNumber}} ? Cette action est irréversible.',
      cancel: 'Annuler',
      deleteSuccess: 'Commande supprimée avec succès',
      deleteError: 'Erreur lors de la suppression',
    },
    messages: {
      publishedSuccess: 'Commande publiée avec succès !',
      publishError: 'Erreur lors de la publication',
    },
  },

  // Bids
  bids: {
    title: 'Offres',
    dialog: {
      title: 'Soumettre une offre',
      description: 'Proposez votre prix pour cette commande',
      amountLabel: 'Montant proposé (€)',
      amountPlaceholder: '850.00',
      messageLabel: 'Message (optionnel)',
      messagePlaceholder: 'Ajoutez des détails sur votre offre...',
      cancelButton: 'Annuler',
      submitButton: 'Soumettre l\'offre',
      submittingButton: 'Envoi...',
    },
    offersReceived: 'Offres reçues',
    offersReceivedCount: 'Offres reçues ({{count}})',
    viewBids: 'Voir les offres',
    noBids: 'Aucune offre pour le moment',
    noBidsReceived: 'Aucune offre reçue pour le moment',
    newBid: 'Nouvelle offre',
    amount: 'Montant',
    proposedAmount: 'Montant proposé',
    message: 'Message',
    submit: 'Soumettre l\'offre',
    accept: 'Accepter',
    decline: 'Refuser',
    accepted: 'Acceptée',
    declined: 'Refusée',
    pending: 'En attente',
    receivedOn: 'Reçue le',
    orderDetails: 'Détails de la commande',
    acceptBid: 'Accepter',
    declineBid: 'Refuser',
  },

  // Marketplace
  marketplace: {
    title: 'Marketplace',
    subtitle: 'Trouvez des commandes disponibles',
    filters: 'Filtres',
    trailerType: 'Type de remorque',
    allTypes: 'Tous types',
    departureCity: 'Ville de départ',
    departureCityPlaceholder: 'Ex: Paris',
    arrivalCity: 'Ville d\'arrivée',
    arrivalCityPlaceholder: 'Ex: Lyon',
    availabilityDate: 'Date de disponibilité',
    selectDate: 'Sélectionner une date',
    sortByDistance: 'Trier par distance',
    noSort: 'Sans tri',
    sortAsc: 'Distance croissante',
    sortDesc: 'Distance décroissante',
    resetFilters: 'Réinitialiser',
    searchOrders: 'Rechercher des commandes...',
    sortBy: 'Trier par',
    sortNewest: 'Plus récentes',
    sortPrice: 'Prix',
    sortDistance: 'Distance',
    noOrders: 'Aucune commande disponible',
    loadMore: 'Charger plus',
    pickupLocation: 'Lieu d\'enlèvement',
    deliveryLocation: 'Lieu de livraison',
    weight: 'Poids',
    vehicleType: 'Type de véhicule',
    price: 'Prix',
    messages: {
      applicationSent: 'Votre candidature a été envoyée avec succès',
    },
    errors: {
      applicationError: 'Erreur lors de l\'envoi de la candidature',
    },
    card: {
      pickup: 'Enlèvement',
      delivery: 'Livraison',
      weight: 'Poids:',
      pallets: 'Palettes:',
      declinedBid: 'Votre offre précédente a été refusée',
      declinedAmount: 'Montant:',
      declinedOn: 'Refusée le',
      pendingBid: 'Votre offre en attente',
      proposedAmount: 'Montant proposé',
      message: 'Message',
      submittedOn: 'Soumise le',
      bookFixed: 'Réserver au prix fixe',
      bidPending: 'Offre en attente de réponse',
      makeNewBid: 'Faire une nouvelle offre',
      makeBid: 'Faire une offre',
      applying: 'Envoi en cours...',
      applyForOrder: 'Postuler pour cette commande',
    },
    placeBid: 'Faire une offre',
    viewDetails: 'Voir les détails',
    bookOrder: 'Réserver',
    bookingSuccess: 'Mission réservée avec succès',
    bookingError: 'Erreur lors de la réservation',
  },

  // Fleet
  fleet: {
    title: 'Gestion de la Flotte',
    subtitle: 'Gérez vos véhicules et chauffeurs',
    vehicles: 'Véhicules',
    drivers: 'Chauffeurs',
    wizard: {
      step1: 'Étape 1 : Type de véhicule',
      step2: 'Étape 2 : Photos de la carte grise',
      step3: 'Étape 3 : Informations du véhicule',
      step1Description: 'Sélectionnez le type de véhicule',
      step2Description: 'Téléchargez les photos (optionnel)',
      step3Description: 'Complétez les informations',
    },
    extraction: {
      analyzing: 'Analyse en cours...',
      analyzingFront: 'Analyse du recto en cours...',
      analyzingBack: 'Analyse du verso en cours...',
      success: 'Données extraites avec succès',
      frontComplete: 'Recto analysé',
      backComplete: 'Verso analysé',
      successDesc: 'Les informations du véhicule ont été automatiquement remplies',
      error: 'Erreur d\'extraction',
      errorDesc: 'Impossible d\'extraire les données. Veuillez remplir manuellement.',
      step1: 'Étape 1/2 : Recto',
      step2: 'Étape 2/2 : Verso',
      optional: 'Photos optionnelles :',
      optionalDesc: 'Vous pouvez prendre des photos de la carte grise pour remplir automatiquement les champs, ou saisir les informations manuellement.',
      notRegistrationCard: 'Document non reconnu',
      notRegistrationCardDesc: 'Cette image ne semble pas être une carte grise. Prenez une photo claire d\'une carte grise valide.',
    },
    dialogs: {
      addVehicle: 'Ajouter un véhicule',
      editVehicle: 'Modifier le véhicule',
      captureRegistration: 'Prendre en photo la carte grise',
      captureRegistrationFront: 'Carte grise - Recto',
      captureRegistrationBack: 'Carte grise - Verso',
      inviteDriver: 'Inviter un chauffeur',
      editDriver: 'Modifier',
      vehicleType: 'Type de véhicule',
      plateNumber: 'Plaque d\'immatriculation',
      plateNumberPlaceholder: 'Ex: AB-123-CD',
      vin: 'Numéro de châssis (VIN)',
      vinPlaceholder: 'Ex: 1HGBH41JXMN109186',
      brand: 'Marque',
      brandPlaceholder: 'Ex: Renault',
      model: 'Modèle',
      modelPlaceholder: 'Ex: Master',
      year: 'Année',
      yearPlaceholder: 'Ex: 2020',
      lastMaintenance: 'Dernier entretien',
      lastMaintenancePlaceholder: 'Sélectionner une date',
      nextMaintenance: 'Prochain entretien',
      nextMaintenancePlaceholder: 'Sélectionner une date',
      status: 'Statut',
      email: 'Email',
      firstName: 'Prénom',
      lastName: 'Nom',
      phone: 'Téléphone',
      licenseNumber: 'Numéro de permis',
      licenseExpiry: 'Date d\'expiration du permis',
      select: 'Sélectionner',
      selectType: 'Sélectionner un type',
      selectVehicleType: 'Sélectionner un type',
      required: '*',
      cancel: 'Annuler',
      add: 'Ajouter',
      addingVehicle: 'Ajout en cours...',
      save: 'Modifier',
      sendInvitation: 'Envoyer l\'invitation',
      statusAvailable: 'Disponible',
      statusOnMission: 'En mission',
      statusOffDuty: 'Hors service',
    },
    invitations: 'Invitations',
    myVehicles: 'Mes Véhicules',
    myDrivers: 'Mes Chauffeurs',
    addVehicle: 'Ajouter un véhicule',
    addDriver: '+ Inviter un chauffeur',
    inviteDriver: 'Inviter un chauffeur',
    addFirstVehicle: 'Ajouter votre premier véhicule',
    inviteFirstDriver: 'Inviter votre premier chauffeur',
    noVehicles: 'Aucun véhicule enregistré',
    noDrivers: 'Aucun chauffeur enregistré',
    noInvitations: 'Aucune invitation',
    pendingInvitations: 'Invitations en attente',
    activeDrivers: 'Chauffeurs actifs',
    vehicleDetails: {
      brand: 'Marque',
      model: 'Modèle',
      year: 'Année',
      plateNumber: 'Plaque',
      type: 'Type',
      status: 'Statut',
      available: 'Disponible',
      unavailable: 'Indisponible',
      inUse: 'En service',
      onMission: 'En mission',
      maintenance: 'Maintenance',
      lastMaintenance: 'Dernière maintenance',
      nextMaintenance: 'Prochaine maintenance',
      vin: 'VIN :',
      modelLabel: 'Modèle :',
      nextMaintenanceLabel: 'Prochain entretien :',
    },
    driverDetails: {
      name: 'Nom',
      email: 'Email',
      phone: 'Téléphone',
      license: 'Permis',
      licenseNumber: 'Numéro de permis',
      licenseExpiry: 'Expiration permis',
      status: 'Statut',
      available: 'Disponible',
      onMission: 'En mission',
      offDuty: 'Hors service',
      unavailable: 'Indisponible',
      noName: 'Chauffeur sans nom',
      licenseExpiresOn: 'Permis expire le',
      position: 'Position',
      positionUnavailable: 'Position non disponible',
      addedOn: 'Ajouté le',
    },
    invitationDetails: {
      email: 'Email',
      phone: 'Téléphone',
      pending: 'En attente',
      expired: 'Expirée',
      expires: 'Expire',
      sentOn: 'Invitation envoyée le',
    },
    cancelInvitation: 'Annuler l\'invitation',
    cancelInvitationTitle: 'Annuler l\'invitation',
    cancelInvitationDescription: 'Êtes-vous sûr de vouloir annuler l\'invitation de {{name}} ({{email}}) ? Cette action est irréversible.',
    confirmCancel: 'Oui, annuler',
    invitationDeleted: 'Invitation annulée',
    invitationDeletedDescription: 'L\'invitation a été supprimée avec succès',
    invitationDeleteError: 'Impossible de supprimer l\'invitation',
    resendEmail: 'Renvoyer l\'email',
    emailResent: 'Email renvoyé',
    emailResentDescription: 'L\'email d\'invitation a été renvoyé à {{email}}',
    actions: {
      edit: 'Modifier',
      delete: 'Supprimer',
      cancel: 'Annuler',
    },
    deleteDialog: {
      vehicleTitle: 'Supprimer le véhicule',
      vehicleDescription: 'Êtes-vous sûr de vouloir supprimer le véhicule',
      driverTitle: 'Supprimer le chauffeur',
      driverDescription: 'Êtes-vous sûr de vouloir supprimer',
      irreversible: 'Cette action est irréversible.',
    },
    documentStatus: {
      verified: 'Vérifié',
      unverified: 'Non vérifié',
      expired: 'Expiré',
      expiringSoon: 'Expire bientôt',
      registrationCard: 'Carte grise',
      driverLicense: 'Permis de conduire',
      scanRegistration: 'Scanner la carte grise',
      scanLicense: 'Scanner le permis',
      rescan: 'Re-scanner',
      lockedField: 'Verrouillé (vérifié par OCR)',
    },
    license: {
      title: 'Vérification du permis',
      howTo: 'Comment faire :',
      howToDesc: 'Prenez en photo le recto et le verso du permis. Les données seront extraites et verrouillées automatiquement.',
      front: 'Recto du permis',
      back: 'Verso du permis',
      captureFront: 'Prendre le recto',
      captureBack: 'Prendre le verso',
      frontDone: 'Recto analysé',
      backDone: 'Verso analysé',
      extracted: 'Données extraites',
      extractedData: 'Données du permis',
      lockedNotice: 'Ces données seront verrouillées et non modifiables manuellement.',
      categories: 'Catégories',
      save: 'Enregistrer le permis',
      saved: 'Permis enregistré',
      savedDesc: 'Le permis a été vérifié et enregistré.',
      incomplete: 'Données incomplètes',
      incompleteDesc: 'Le numéro et la date d\'expiration sont obligatoires.',
      notALicense: 'Document non reconnu',
      notALicenseDesc: 'Cette image ne semble pas être un permis de conduire. Veuillez prendre une photo claire d\'un permis valide.',
    },
  },

  // Driver - Report Delay
  driver: {
    reportDelay: {
      title: 'Signaler un retard',
      estimatedDelay: 'Délai estimé *',
      selectDelay: 'Sélectionnez un délai',
      custom: 'Personnalisé',
      customMinutesPlaceholder: 'Ex: 90',
      reason: 'Raison (optionnel)',
      reasonPlaceholder: 'Ex: Embouteillages sur A1',
      minutes15: '15 minutes',
      minutes30: '30 minutes',
      minutes45: '45 minutes',
      minutes60: '1 heure',
      minutes90: '1h30',
      minutes120: '2 heures',
      confirmButton: 'Confirmer',
      errorInvalidCustom: 'Veuillez entrer un délai personnalisé valide (en minutes)',
    },
  },

  // Missions
  missions: {
    myMissions: 'Mes Missions',
    subtitle: 'Gérez vos missions de transport',
    all: 'Toutes',
    pending: 'En attente',
    upcoming: 'À venir',
    ongoing: 'En cours',
    active: 'Actives',
    completed: 'Terminées',
    assigned: 'Assignées',
    search: 'Rechercher par numéro, ville ou adresse...',
    noResults: 'Aucune mission ne correspond à votre recherche',
    resultFound: 'résultat trouvé',
    resultsFound: 'résultats trouvés',
    noMissions: 'Aucune mission',
    noMissionPending: 'Aucune mission en attente',
    noMissionActive: 'Aucune mission active',
    noMissionCompleted: 'Aucune mission terminée',
    filters: {
      title: 'Filtres',
      trailerType: 'Type de remorque',
      distance: 'Distance',
      allTrailers: 'Tous les types',
      allDistances: 'Toutes les distances',
      distance0to100: 'Moins de 100 km',
      distance100to500: '100 - 500 km',
      distance500to1000: '500 - 1000 km',
      distance1000plus: 'Plus de 1000 km',
      clearFilters: 'Réinitialiser les filtres',
    },
    assignDriver: 'Assigner un chauffeur',
    assignVehicle: 'Assigner un véhicule',
    startMission: 'Démarrer la mission',
    completeMission: 'Terminer la mission',
    orderNumber: 'Numéro de commande',
    pickup: 'Enlèvement',
    delivery: 'Livraison',
    status: 'Statut',
    accept: 'Accepter',
    decline: 'Refuser',
    scanQR: 'Scanner QR',
    openDocuments: 'Documents',
    uploadPOD: 'Télécharger POD',
    reportDelay: 'Signaler un retard',
    actions: {
      assign: 'Assigner',
      viewDetails: 'Voir détails',
      accept: 'Accepter',
      decline: 'Refuser',
      refuse: 'Refuser',
      scanQR: 'Scanner QR',
      documents: 'Documents',
      viewDocuments: 'Voir les documents',
      reportDelay: 'Signaler un retard',
      route: 'Itinéraire',
    },
    history: 'Historique',
    inProgress: 'En cours',
    card: {
      orderNumber: 'Commande N°',
      from: 'De',
      to: 'Vers',
      order: 'Commande',
      weight: 'Poids',
      type: 'Type',
      price: 'Prix',
      driver: 'Chauffeur:',
      vehicle: 'Véhicule:',
      assign: 'Assigner',
      pickup: 'Enlèvement',
      delivery: 'Livraison',
      cargo: 'Marchandise',
      notAssigned: 'Non assigné',
      assignDriver: 'Assigner un chauffeur',
      delayReported: 'Retard signalé',
      status: {
        completed: 'Terminée',
        inProgress: 'En cours',
        assigned: 'Assignée',
        pending: 'En attente',
      },
    },
    empty: {
      assigned: 'Aucune mission assignée',
      active: 'Aucune mission active',
      completed: 'Aucune mission terminée',
    },
  },

  // Billing
  billing: {
    title: 'Facturation',
    detailsTitle: 'Détails',
    subtitle: 'Gérez vos bons de commande et factures',
    filterByStatus: 'Filtrer par statut',
    allStatuses: 'Tous les statuts',
    documentType: 'Type de document',
    documentNumber: 'Numéro',
    amount: 'Montant HT',
    vatRate: 'Taux de TVA',
    vatAmount: 'Montant TVA',
    totalAmount: 'Total TTC',
    issueDate: 'Date d\'émission',
    dueDate: 'Date d\'échéance',
    paidDate: 'Date de paiement',
    types: {
      order_form: 'Bon de commande',
      invoice: 'Facture',
    },
    stats: {
      title: 'Vue d\'ensemble',
      totalInvoiced: 'Total facturé',
      totalPaid: 'Total payé',
      totalPending: 'En attente',
      paymentProgress: 'Progression des paiements',
    },
    statuses: {
      draft: 'Brouillon',
      sent: 'Envoyé',
      paid: 'Payé',
      cancelled: 'Annulé',
    },
    tabs: {
      orderForms: 'Bons de commande',
      invoices: 'Factures',
    },
    emptyStates: {
      orderForms: {
        title: 'Aucun bon de commande',
        description: 'Les bons de commande apparaîtront ici une fois générés.',
      },
      invoices: {
        title: 'Aucune facture',
        description: 'Les factures apparaîtront ici une fois générées.',
      },
    },
    messages: {
      pdfSuccess: 'PDF téléchargé avec succès',
      pdfError: 'Erreur lors de la génération du PDF',
      markedAsPaid: 'Document marqué comme payé',
      titleRequired: 'Le titre ne peut pas être vide',
      titleUpdated: 'Titre mis à jour avec succès',
    },
    status: {
      paid: 'Payé',
      sent: 'Envoyé',
      cancelled: 'Annulé',
      draft: 'Brouillon',
    },
    documentTypes: {
      orderForm: 'Bon de commande',
      invoice: 'Facture',
    },
    card: {
      order: 'Commande:',
      route: 'Trajet:',
      amountHT: 'Montant HT',
      vat: 'TVA',
      totalTTC: 'Total TTC',
      issuedOn: 'Émis le:',
      dueDate: 'Échéance:',
      paidOn: 'Payé le:',
      view: 'Consulter',
      pdf: 'PDF',
    },
    dialog: {
      documentNumber: 'Numéro de document',
      customTitle: 'Titre personnalisé',
      noTitle: 'Sans titre',
      titlePlaceholder: 'Saisissez un titre pour ce document',
      shipper: 'Expéditeur',
      transporter: 'Transporteur',
      orderDetails: 'Détails de la commande',
      orderNumber: 'Numéro de commande:',
      cargo: 'Marchandise:',
      route: 'Trajet:',
      financialDetails: 'Détails financiers',
      amountHT: 'Montant HT',
      vat: 'TVA',
      totalTTC: 'Total TTC',
      importantDates: 'Dates importantes',
      issueDate: 'Date d\'émission',
      dueDate: 'Date d\'échéance',
      paymentDate: 'Date de paiement',
      notes: 'Notes',
      markAsPaid: 'Marquer comme payé',
      downloadPDF: 'Télécharger PDF',
    },
    // Keeping old keys for compatibility
    orderForms: 'Bons de commande',
    invoices: 'Factures',
    noDocuments: 'Aucun document',
    type: 'Type',
    date: 'Date',
    paid: 'Payé',
    unpaid: 'Non payé',
    overdue: 'En retard',
    markAsPaid: 'Marquer comme payé',
    viewDocument: 'Voir le document',
    downloadPDF: 'Télécharger PDF',
    details: {
      shipper: 'Expéditeur',
      transporter: 'Transporteur',
      orderDetails: 'Détails de la commande',
      route: 'Itinéraire',
      cargo: 'Marchandise',
      financial: 'Récapitulatif financier',
      subtotal: 'Sous-total',
      vat: 'TVA',
      total: 'Total TTC',
      createdAt: 'Date de création',
      dueDate: 'Date d\'échéance',
      paidAt: 'Date de paiement',
    },
  },

  // Notifications
  notifications: {
    title: 'Notifications',
    markAllRead: 'Tout marquer comme lu',
    markAll: 'Tout marquer',
    noNotifications: 'Aucune notification',
    empty: 'Aucune notification',
    markAsReadError: 'Erreur lors du marquage de la notification',
    markAllAsReadError: 'Erreur lors du marquage des notifications',
    allMarkedAsRead: 'Toutes les notifications marquées comme lues',
    notificationNotFound: 'Impossible de trouver cette commande',
    types: {
      mission_assigned: 'Mission assignée',
      new_bid: 'Nouvelle offre',
      bid_accepted: 'Offre acceptée',
      bid_declined: 'Offre refusée',
      order_updated: 'Commande mise à jour',
      mission_started: 'Mission démarrée',
      mission_completed: 'Mission terminée',
      payment_received: 'Paiement reçu',
      rating_reminder: 'Rappel de notation',
    },
  },

  // Navigation
  nav: {
    dashboard: 'Dashboard',
    marketplace: 'Marketplace',
    missions: 'Missions',
    liveMap: 'Carte en direct',
    myMissions: 'Mes Missions',
    myOrders: 'Mes commandes',
    fleet: 'Flotte',
    billing: 'Facturation',
    settings: 'Paramètres',
    logout: 'Déconnexion',
  },

  // Tracking
  liveMap: {
    description: 'Suivez toutes vos missions en cours en temps réel',
    noActiveMissions: 'Aucune mission active pour le moment',
    filters: 'Filtres',
    searchPlaceholder: 'Rechercher par n° de commande...',
    noResults: 'Aucune mission ne correspond aux filtres',
    dateFilter: 'Période',
    allOrders: 'Toutes les commandes',
    today: 'Aujourd\'hui',
    last7Days: '7 derniers jours',
    last30Days: '30 derniers jours',
    last90Days: '90 derniers jours',
    last365Days: '365 derniers jours',
  },

  tracking: {
    title: 'Suivi de commande',
    orderNotFound: 'Commande introuvable',
    returnToDashboard: 'Retour au tableau de bord',
    deliveryDocuments: 'Documents de livraison',
    trackingHistory: 'Historique du suivi',
    trackingMap: 'Carte de suivi',
    noEvents: 'Aucun événement de suivi pour le moment',
    interactiveMap: 'Carte interactive',
    noCoordinates: 'Coordonnées GPS non disponibles pour cette commande',
    events: {
      pickup_confirmed: 'Enlèvement confirmé',
      in_transit: 'En transit',
      delivered: 'Livré',
      exception: 'Exception',
    },
  },

  // Settings
  settings: {
    companyDocuments: {
      title: 'Documents ajoutés par Velox',
      description: "Documents rattachés à votre société par l'équipe Velox.",
      empty: 'Aucun document ajouté pour le moment.',
    },
    title: 'Paramètres',
    subtitle: 'Gérez vos informations personnelles et de compte',
    tabs: {
      profile: 'Profil',
      company: 'Entreprise',
      language: 'Langue',
      email: 'Email',
      password: 'Mot de passe',
      notifications: 'Notifications',
    },
    profile: {
      title: 'Informations personnelles',
      description: 'Mettez à jour vos informations personnelles',
      firstName: 'Prénom',
      lastName: 'Nom',
      phone: 'Téléphone',
      save: 'Enregistrer les modifications',
      companyLogo: 'Logo de l\'entreprise',
      profilePhoto: 'Photo de profil',
      changeImage: 'Changer l\'image',
      imageHint: 'JPG, PNG ou WebP. Max 2 Mo.',
      imageUploadSuccess: 'Image mise à jour avec succès',
      imageUploadError: 'Erreur lors du téléchargement de l\'image',
      imageTypeError: 'Format non supporté. Utilisez JPG, PNG ou WebP.',
      imageSizeError: 'Le fichier est trop volumineux. Maximum 2 Mo.',
    },
    company: {
      title: 'Informations de l\'entreprise',
      description: 'Gérez les informations de votre entreprise',
      name: 'Nom de l\'entreprise',
      registrationNumber: 'Identifiant fiscal',
      registrationNumberDescription: 'SIRET, numéro de TVA, ou autre identifiant fiscal selon votre pays',
      iban: 'IBAN (optionnel)',
      ibanPlaceholder: 'BE71 0961 2345 6769',
      ibanDescription: 'Utilisé pour les paiements et la facturation. Vous pouvez le renseigner plus tard.',
      ibanInvalid: 'IBAN invalide',
      address: 'Adresse',
      phone: 'Téléphone',
      save: 'Enregistrer les modifications',
    },
    language: {
      title: 'Langue de l\'interface',
      description: 'Choisissez votre langue préférée',
      label: 'Langue',
      note: 'La langue sera appliquée à toute l\'interface',
    },
    email: {
      title: 'Adresse email',
      description: 'Modifiez votre adresse email de connexion',
      newEmail: 'Nouvelle adresse email',
      update: 'Mettre à jour l\'email',
      notifications: {
        label: 'Notifications par email',
        description: 'Recevoir des notifications importantes par email',
      },
    },
    password: {
      title: 'Mot de passe',
      description: 'Changez votre mot de passe de connexion',
      currentPassword: 'Mot de passe actuel',
      newPassword: 'Nouveau mot de passe',
      confirmPassword: 'Confirmer le mot de passe',
      save: 'Changer le mot de passe',
    },
    notifications: {
      title: 'Notifications',
      description: 'Gérez vos préférences de notifications',
      emailLabel: 'Notifications par email',
      emailDescription: 'Recevoir des notifications par email',
    },
    validation: {
      firstNameRequired: 'Le prénom est requis',
      lastNameRequired: 'Le nom est requis',
      companyNameRequired: 'Le nom de l\'entreprise est requis',
      maxLength: 'Maximum {{max}} caractères',
      emailInvalid: 'Email invalide',
      passwordMin: 'Minimum 6 caractères',
      passwordMismatch: 'Les mots de passe ne correspondent pas',
    },
    messages: {
      profileUpdated: 'Profil mis à jour avec succès',
      profileError: 'Erreur lors de la mise à jour du profil',
      companyUpdated: 'Entreprise mise à jour avec succès',
      companyError: 'Erreur lors de la mise à jour de l\'entreprise',
      emailSent: 'Email de confirmation envoyé',
      emailError: 'Erreur lors de la mise à jour de l\'email',
      currentPasswordIncorrect: 'Mot de passe actuel incorrect',
      passwordUpdated: 'Mot de passe mis à jour avec succès',
      passwordError: 'Erreur lors de la mise à jour du mot de passe',
      languageUpdated: 'Langue mise à jour avec succès',
      languageError: 'Erreur lors de la mise à jour de la langue',
      emailPreferencesUpdated: 'Préférences de notifications mises à jour',
      notificationsUpdated: 'Préférences de notifications mises à jour',
      notificationsError: 'Erreur lors de la mise à jour des notifications',
    },
  },

  // Vehicle Types (Trailer Types)
  vehicleTypes: {
    van: 'Fourgon',
    flatbed: 'Plateau',
    refrigerated: 'Frigorifique',
    tanker: 'Citerne',
    curtainsider: 'Bâché',
    lowloader: 'Porte-engin',
    container: 'Porte-conteneur',
    any: 'Tous types',
    car: 'Porte-voiture',
    van_small: 'Petit fourgon',
    utility: 'Utilitaire',
    other: 'Autre',
  },

  // Admin
  admin: {
    title: "Panneau d'Administration",
    unpaidPayments: "Paiements en attente",
    auditLogs: "Audit Logs",
    allPaid: "Tous les paiements sont à jour",
    noPendingOrders: "Aucune commande en attente de paiement",
    transporter: "Transporteur",
    orders: "Commandes",
    totalAmount: "Montant total",
    action: "Action",
    markPaid: "Marquer payé",
    confirmPayment: "Confirmer le paiement",
    confirmPaymentText: "Êtes-vous sûr de vouloir marquer comme payées les {{count}} commande(s) de {{name}} pour un montant total de {{amount}} € ?",
    recording: "Enregistrement...",
    cancel: "Annuler",
    filters: "Filtres",
    reset: "Réinitialiser",
    table: "Table",
    allTables: "Toutes les tables",
    allActions: "Toutes les actions",
    dateFrom: "Date début",
    dateTo: "Date fin",
    noAuditLogs: "Aucun audit log trouvé",
    tryModifyFilters: "Essayez de modifier vos filtres",
    logsWillAppear: "Les logs d'audit apparaîtront ici",
    timestamp: "Timestamp",
    user: "Utilisateur",
    details: "Détails",
    system: "Système",
    oldValues: "Anciennes valeurs",
    newValues: "Nouvelles valeurs",
    clickToSee: "Cliquer pour voir",
    
    // Navigation
    nav: {
      dashboard: 'Dashboard',
      users: 'Utilisateurs & Entreprises',
      orders: 'Commandes',
      invoices: 'Factures',
      stats: 'Statistiques',
    },
    
    // Dashboard
    dashboard: {
      title: 'Dashboard Admin',
      subtitle: 'Vue d\'ensemble de la plateforme',
      filters: {
        day: 'Aujourd\'hui',
        week: 'Cette semaine',
        month: 'Ce mois',
      },
      revenue: 'Chiffre d\'affaires',
      ordersDelivered: 'Commandes livrées',
      ordersPosted: 'Commandes postées',
      ordersInProgress: 'En cours',
      vsLastPeriod: 'vs. période précédente',
      vsAverage: 'vs. moyenne',
      revenueChart: 'Évolution du chiffre d\'affaires',
      ordersChart: 'Évolution des commandes',
    },
    
    // Users & Companies
    users: {
      title: 'Utilisateurs & Entreprises',
      subtitle: 'Gestion des utilisateurs et entreprises',
      name: 'Nom',
      email: 'Email',
      company: 'Entreprise',
      role: 'Rôle',
      status: 'Statut',
      registrationDate: 'Date d\'inscription',
      actions: 'Actions',
      suspend: 'Suspendre',
      delete: 'Supprimer',
      promoteAdmin: 'Promouvoir admin',
      viewDetails: 'Voir détails',
      filters: {
        role: 'Filtrer par rôle',
        status: 'Filtrer par statut',
        company: 'Filtrer par entreprise',
        date: 'Filtrer par date',
        allRoles: 'Tous les rôles',
        allStatuses: 'Tous les statuts',
        allCompanies: 'Toutes les entreprises',
      },
      statuses: {
        active: 'Actif',
        suspended: 'Suspendu',
        deleted: 'Supprimé',
      },
      showDeleted: 'Afficher les comptes supprimés',
      deletedHiddenCount: '{{count}} compte(s) supprimé(s) masqué(s)',
      userDetails: {
        title: 'Détails utilisateur',
        personalInfo: 'Informations personnelles',
        companyInfo: 'Informations entreprise',
        phone: 'Téléphone',
        language: 'Langue préférée',
        emailNotifications: 'Notifications email',
        enabled: 'Activées',
        disabled: 'Désactivées',
      },
      companyDetails: {
        createdAt: 'Créée le',
        companyCreatedSince: 'Depuis le {{date}}',
        title: 'Détails entreprise',
        type: 'Type',
        siret: 'SIRET',
        address: 'Adresse',
        users: 'Utilisateurs associés',
        fleet: 'Flotte',
        drivers: 'Chauffeurs',
        documents: 'Documents',
        vehicleCount: 'Véhicules',
        driverCount: 'Chauffeurs',
        documentStatus: 'Statut documents',
        valid: 'Valides',
        expired: 'Expirés',
        missing: 'Manquants',
      },
      confirmSuspend: 'Confirmer la suspension',
      confirmSuspendMessage: 'Êtes-vous sûr de vouloir suspendre cet utilisateur ?',
      confirmDelete: 'Supprimer définitivement ce compte',
      confirmDeleteMessage: 'Le compte sera anonymisé : les données personnelles seront effacées et l\'accès sera bloqué définitivement. L\'historique des commandes est conservé. Cette action est irréversible.',
      deleteSuccess: 'Compte supprimé et anonymisé',
      deleteError: 'Erreur lors de la suppression du compte',
      confirmPromote: 'Confirmer la promotion',
      confirmPromoteMessage: 'Êtes-vous sûr de vouloir promouvoir cet utilisateur en administrateur ?',
      userSuspended: 'Utilisateur suspendu',
      userDeleted: 'Utilisateur supprimé',
      userPromoted: 'Utilisateur promu administrateur',
      error: 'Une erreur est survenue',
    },
    
    // Orders
    adminOrders: {
      title: 'Commandes',
      subtitle: 'Gestion des commandes',
      orderId: 'ID Commande',
      shipper: 'Expéditeur',
      transporter: 'Transporteur',
      amount: 'Montant',
      status: 'Statut',
      date: 'Date',
      actions: 'Actions',
      viewDetails: 'Voir détails',
      markDelivered: 'Marquer livrée',
      cancelOrder: 'Annuler',
      viewInvoice: 'Voir facture',
      filters: {
        status: 'Filtrer par statut',
        date: 'Filtrer par date',
        shipper: 'Filtrer par expéditeur',
        transporter: 'Filtrer par transporteur',
        allStatuses: 'Tous les statuts',
      },
      orderDetails: {
        title: 'Détails de la commande',
        route: 'Itinéraire',
        cargo: 'Cargaison',
        pricing: 'Tarification',
        documents: 'Documents',
        tracking: 'Suivi',
      },
      confirmMarkDelivered: 'Confirmer la livraison',
      confirmMarkDeliveredMessage: 'Êtes-vous sûr de vouloir marquer cette commande comme livrée ?',
      confirmCancel: 'Confirmer l\'annulation',
      confirmCancelMessage: 'Êtes-vous sûr de vouloir annuler cette commande ?',
      orderMarkedDelivered: 'Commande marquée comme livrée',
      orderCancelled: 'Commande annulée',
      error: 'Une erreur est survenue',
    },
    
    // Invoices
    invoices: {
      title: 'Factures',
      subtitle: 'Gestion des factures',
      invoiceId: 'ID Facture',
      shipper: 'Expéditeur',
      transporter: 'Transporteur',
      amount: 'Montant',
      status: 'Statut',
      date: 'Date',
      actions: 'Actions',
      markPaidAction: 'Marquer comme payée',
      report: 'Signaler',
      viewDetails: 'Voir détails',
      statuses: {
        pending: 'À traiter',
        paid: 'Payée',
        reported: 'Signalée',
        cancelled: 'Annulée',
      },
      invoiceDetails: {
        title: 'Détails de la facture',
        shipperInfo: 'Informations expéditeur',
        transporterInfo: 'Informations transporteur',
        orderInfo: 'Informations commande',
        history: 'Historique',
        comments: 'Commentaires admin',
        addComment: 'Ajouter un commentaire',
      },
      confirmMarkPaid: 'Confirmer le paiement',
      confirmMarkPaidMessage: 'Êtes-vous sûr de vouloir marquer cette facture comme payée ?',
      confirmReport: 'Signaler la facture',
      confirmReportMessage: 'Êtes-vous sûr de vouloir signaler cette facture ?',
      confirmCancel: 'Annuler la facture',
      confirmCancelMessage: 'Êtes-vous sûr de vouloir annuler cette facture ? Cette action est irréversible.',
      reportReason: 'Raison du signalement',
      invoiceMarkedPaid: 'Facture marquée comme payée',
      invoiceReported: 'Facture signalée',
      commentAdded: 'Commentaire ajouté',
      error: 'Une erreur est survenue',
    },
  },

  // Shipper
  shipper: {
    dashboard: {
      title: "Tableau de bord Expéditeur",
      createOrder: "Créer une commande",
      pendingReservations: "Réservations en attente de confirmation",
      pendingReservationsSubtitle: "{{count}} transporteur(s) ont réservé vos commandes",
      pendingBids: 'Offres reçues',
      pendingBidsSubtitle: 'Vous avez {{count}} offre(s) en attente de validation',
      ordersInProgress: "Commandes en cours",
      ordersInProgressSubtitle: "Vos commandes assignées et en transit",
      viewAllOrders: "Voir toutes mes commandes",
      noOrdersInProgress: "Aucune commande en cours pour le moment",
    },
    stats: {
      totalOrders: "Total commandes",
      inProgress: "En cours",
      delivered: "Livrées",
      drafts: "Brouillons",
    },
    reservation: {
      pending: 'Réservation en attente',
      transporter: 'Transporteur',
      confirming: 'Confirmation...',
      confirm: 'Confirmer',
      declining: 'Refus...',
      decline: 'Refuser',
    },
    bids: {
      order: 'Commande',
      pickup: 'Enlèvement',
      delivery: 'Livraison',
      transporter: 'Transporteur',
      proposedAmount: 'Montant proposé',
      message: 'Message',
      submittedOn: 'Soumis le',
    },
    messages: {
      reservationConfirmed: "Réservation confirmée avec succès",
      reservationDeclined: "Réservation refusée",
      bidAccepted: 'Offre acceptée avec succès',
      bidDeclined: 'Offre refusée',
    },
    errors: {
      confirmError: 'Erreur lors de la confirmation',
      declineError: 'Erreur lors du refus',
      acceptBidError: "Erreur lors de l'acceptation de l'offre",
      declineBidError: "Erreur lors du refus de l'offre",
    },
  },

  // Transporter
  transporter: {
    dashboard: {
      title: "Tableau de bord Transporteur",
      activeMissions: "Missions actives",
      noActiveMissions: "Aucune mission active",
      checkMarketplace: "Consultez le marketplace pour réserver des missions",
      cancelMissionConfirm: "Voulez-vous vraiment annuler la mission {{orderNumber}} ?",
    },
    stats: {
      availableVehicles: "Véhicules disponibles",
      activeMissions: "Missions en cours",
      availableDrivers: "Chauffeurs disponibles",
      completedMissions: "Missions terminées",
    },
    mission: {
      pendingConfirmation: "En attente de confirmation",
      assigned: "Assignée",
      accepted: "Acceptée",
      pickup: "Enlèvement",
      delivery: "Livraison",
      driver: "Chauffeur:",
      vehicle: "Véhicule:",
    },
    messages: {
      missionCanceled: "Mission annulée avec succès",
    },
  },

  // Landing
  landing: {
    hero: {
      title: "Velox",
      titleHighlight: "gérez vos missions de transport,",
      titleEnd: "sans effort",
      subtitle: "Une Progressive Web App optimisée pour desktop et mobile : publiez du fret, accédez au marketplace, assignez des chauffeurs, validez via QR code et gérez les paiements — tout en un seul endroit.",
      tryFree: "Essayer gratuitement",
      learnMore: "En savoir plus",
      cta: "S'inscrire",
    },
    allYouNeed: {
      title: "Tout ce dont vous avez besoin",
      subtitle: "Une plateforme complète pour gérer efficacement votre activité de transport",
    },
    features: {
      title: "Fonctionnalités principales",
      shipments: {
        title: "Gestion des expéditions",
        description: "Créez, suivez et gérez vos commandes de transport en temps réel avec une interface intuitive.",
      },
      fleet: {
        title: "Gestion de flotte",
        description: "Optimisez l'utilisation de vos véhicules et chauffeurs avec des outils de planification avancés.",
      },
      tracking: {
        title: "Suivi en temps réel",
        description: "Localisez vos livraisons en direct et tenez vos clients informés à chaque étape.",
      },
      multiUser: {
        title: "Multi-utilisateurs",
        description: "Collaborez efficacement avec votre équipe grâce à des rôles et permissions personnalisés.",
      },
      planning: {
        title: "Planification intelligente",
        description: "Optimisez vos tournées et planifiez vos missions avec des algorithmes intelligents.",
      },
      security: {
        title: "Sécurité maximale",
        description: "Vos données sont protégées avec les standards de sécurité les plus élevés.",
      },
    },
    workflow: {
      title: "Processus principal",
      subtitle: "V1 - marketplace complète et déroulé du processus",
      steps: {
        step1: {
          badge: "Étape 1",
          title: "Publication du fret (Expéditeur)",
          description: "Création du compte entreprise, configuration de la commande (type de remorque, destination, fenêtre de livraison, prix proposé). La commande apparaît sur la marketplace.",
        },
        step2: {
          badge: "Étape 2",
          title: "Sélection et réservation (Transporteur)",
          description: "Enregistrement du transporteur et intégration des chauffeurs. Marketplace avec filtres (itinéraire, type de cargaison, distance). Réservation et confirmation du fret.",
        },
        step3: {
          badge: "Étape 3",
          title: "Attribution du chauffeur",
          description: "Lien automatique envoyé pour la création du compte chauffeur lié à l'entreprise. Le chauffeur accepte la mission via la PWA.",
        },
        step4: {
          badge: "Étape 4",
          title: "Chargement et départ",
          description: "Le chauffeur s'enregistre au site de chargement. Validation via code QR ou confirmation manuelle → statut passe à \"en transit\".",
        },
        step5: {
          badge: "Étape 5",
          title: "Livraison",
          description: "Validation via code QR ou bouton \"Livré\". Upload de photos et documents POD/CMR. Les notifications sont envoyées instantanément, statut mis à jour sur le tableau de bord.",
        },
        step6: {
          badge: "Étape 6",
          title: "Paiement et clôture",

          description: "L'administrateur valide les commandes livrées pour les paiements quotidiens. La facture est générée automatiquement. L'expéditeur reçoit la facture et évalue le transporteur.",
        },
      },
    },
    comparison: {
      title: "Trouvez la solution qui vous correspond",
      subtitle: "Que vous soyez expéditeur ou transporteur, Velox simplifie la gestion de vos opérations de transport",
      shipper: {
        title: "Expéditeurs",
        benefits: [
          "Publiez vos commandes de fret en quelques clics",
          "Accédez à un réseau de transporteurs vérifiés",
          "Suivez vos livraisons en temps réel",
          "Gérez vos factures et paiements facilement",
          "Bénéficiez d'un service client dédié"
        ],
        cta: "Commencer en tant qu'expéditeur"
      },
      transporter: {
        title: "Transporteurs",
        benefits: [
          "Accédez à des milliers d'offres de fret",
          "Optimisez l'utilisation de votre flotte",
          "Gérez vos chauffeurs et véhicules simplement",
          "Recevez vos paiements rapidement",
          "Développez votre activité efficacement"
        ],
        cta: "Commencer en tant que transporteur"
      }
    },
    faq: {
      title: 'Foire Aux Questions',
      subtitle: 'Tout ce que vous devez savoir sur Velox',
      questions: {
        whatIsVelox: {
          question: 'Qu\'est-ce que Velox ?',
          answer: 'Velox est une Progressive Web App conçue pour simplifier la gestion des missions de transport entre expéditeurs, transporteurs et chauffeurs. Elle centralise la publication de fret, la réservation, l\'affectation, la validation de livraison et le suivi des paiements.',
        },
        needDownload: {
          question: 'Dois-je télécharger une application ?',
          answer: 'Non. Velox est une PWA — elle fonctionne directement sur les navigateurs de bureau et mobiles. Aucune installation depuis l\'App Store ou Google Play n\'est requise.',
        },
        whoCanUse: {
          question: 'Qui peut utiliser Velox ?',
          answer: 'Velox supporte trois types d\'utilisateurs principaux : les Expéditeurs (publier des commandes de fret et suivre les livraisons), les Transporteurs (parcourir et réserver du fret, assigner des missions aux chauffeurs), et les Chauffeurs (recevoir des missions, valider les étapes, télécharger des documents de livraison).',
        },
        driverJoin: {
          question: 'Comment les chauffeurs rejoignent-ils la plateforme ?',
          answer: 'Les chauffeurs reçoivent un lien automatique de leur transporteur. Ils créent un compte chauffeur connecté en quelques étapes seulement.',
        },
        deliveryValidation: {
          question: 'Comment la livraison est-elle validée ?',
          answer: 'La livraison peut être validée en scannant un QR code ou via un bouton de confirmation manuel. Les chauffeurs peuvent également télécharger directement des documents POD/CMR et des photos.',
        },
        notifications: {
          question: 'Quel type de notifications sont envoyées ?',
          answer: 'Velox envoie des notifications par email aux expéditeurs, transporteurs et chauffeurs pour les événements clés : réservations, affectations de missions, mises à jour de statut et confirmations de livraison.',
        },
        multilingual: {
          question: 'Velox est-il multilingue et multi-devises ?',
          answer: 'Oui. La PWA supporte plusieurs langues et devises pour s\'adapter à différents marchés.',
        },
        payment: {
          question: 'Comment fonctionne le paiement ?',
          answer: 'Une fois qu\'une livraison est marquée comme terminée, l\'Admin Velox la valide pour le paiement quotidien. Une facture est générée automatiquement et envoyée à l\'expéditeur.',
        },
        history: {
          question: 'Puis-je voir mes missions ou expéditions passées ?',
          answer: 'Absolument. Velox inclut un historique complet pour chaque rôle : Expéditeur (livraisons, coûts, KPI), Transporteur (expéditions, notes, préférences), et Chauffeur (missions + tous les documents associés).',
        },
        production: {
          question: 'Velox est-il une application en production ?',
          answer: 'Cette version est un prototype (V1) axé sur le workflow principal et les capacités de marketplace. Plus de fonctionnalités seront ajoutées dans les prochaines itérations.',
        },
      },
    },
    ctaSection: {
      title: "Prêt à transformer votre logistique ?",
      subtitle: "Rejoignez les entreprises qui optimisent leur transport avec Velox",
      createAccount: "Créer un compte gratuit",
    },
    cta: {
      title: "Prêt à commencer ?",
      subtitle: "Rejoignez-nous dès aujourd'hui",
    },
    footer: {
      copyright: "© 2025 Velox. Tous droits réservés.",
    },
  },


  // Not Found
  notFound: {
    message: "Oops ! Page introuvable",
    backToHome: "Retour à l'accueil",
  },

  // Create Order - Country Codes
  createOrder: {
    countryCodes: {
      france: 'France',
      belgium: 'Belgique',
      switzerland: 'Suisse',
      germany: 'Allemagne',
      spain: 'Espagne',
      italy: 'Italie',
      netherlands: 'Pays-Bas',
      uk: 'Royaume-Uni',
      portugal: 'Portugal',
      luxembourg: 'Luxembourg',
      austria: 'Autriche',
      denmark: 'Danemark',
      sweden: 'Suède',
      norway: 'Norvège',
      poland: 'Pologne',
      czech: 'Tchéquie',
      slovakia: 'Slovaquie',
      hungary: 'Hongrie',
      romania: 'Roumanie',
      greece: 'Grèce',
      ireland: 'Irlande',
      finland: 'Finlande',
      usaCanada: 'USA/Canada',
      mexico: 'Mexique',
      brazil: 'Brésil',
      argentina: 'Argentine',
      chile: 'Chili',
      colombia: 'Colombie',
      venezuela: 'Venezuela',
      china: 'Chine',
      japan: 'Japon',
      southKorea: 'Corée du Sud',
      india: 'Inde',
      singapore: 'Singapour',
      malaysia: 'Malaisie',
      thailand: 'Thaïlande',
      vietnam: 'Vietnam',
      indonesia: 'Indonésie',
      philippines: 'Philippines',
      uae: 'Émirats',
      saudiArabia: 'Arabie Saoudite',
      israel: 'Israël',
      turkey: 'Turquie',
      southAfrica: 'Afrique du Sud',
      morocco: 'Maroc',
      algeria: 'Algérie',
      tunisia: 'Tunisie',
      nigeria: 'Nigeria',
      kenya: 'Kenya',
      australia: 'Australie',
      newZealand: 'Nouvelle-Zélande',
    },
    title: 'Créer une commande',
    subtitle: 'Remplissez les informations de votre transport',
    
    section1: {
      title: '1. Itinéraire',
      description: 'Informations sur le départ et la livraison',
      pickup: 'Départ',
      delivery: 'Livraison',
    },
    
    address: {
      streetNumber: 'Numéro',
      streetName: 'Nom de rue',
      postalCode: 'Code postal',
      city: 'Ville',
      country: 'Pays',
      streetNumberPlaceholder: '123',
      streetNamePlaceholder: 'Rue de la République',
      postalCodePlaceholder: '75000',
      cityPlaceholder: 'Paris',
      countryPlaceholder: 'France',
    },
    
    dateTime: {
      pickupDate: 'Date de départ',
      pickupTime: 'Heure de départ',
      deliveryDate: 'Date de livraison',
      deliveryTime: 'Heure de livraison',
      chooseDate: 'Choisir une date',
    },
    
    contact: {
      label: 'Contact',
      phone: 'Téléphone',
      contactPlaceholder: 'Jean Dupont',
      phonePlaceholder: '6 12 34 56 78',
    },
    
    access: {
      detailsLabel: "Détails d'accès (optionnel)",
      detailsPlaceholder: 'Ex: Code portail 1234, Entrée par le parking arrière, Sonner au bureau 3...',
      detailsHelper: "Précisez les subtilités pour accéder au lieu de départ",
      deliveryDetailsPlaceholder: 'Ex: Sonnette 2ème étage, Livraison côté rue, Accès parking visiteurs...',
      deliveryDetailsHelper: "Précisez les subtilités pour accéder au lieu de livraison",
      photosLabel: "Photos d'accès (optionnel)",
      photosHelper: "Maximum 5 images pour aider à trouver le lieu de départ",
      deliveryPhotosHelper: "Maximum 5 images pour aider à trouver le lieu de livraison",
      maxImagesError: 'Maximum 5 images autorisées',
    },
    
    gps: {
      calculating: 'Calcul de la position GPS...',
      calculated: 'Position GPS calculée',
    },
    
    section2: {
      title: '2. Marchandise',
      subtitle: 'Détails de la cargaison à transporter',
      cargoTitle: 'Titre de la marchandise',
      cargoTitlePlaceholder: 'Ex: Palettes de produits électroniques, Mobilier de bureau...',
      vehicleType: 'Type de véhicule',
      vehicleTypePlaceholder: 'Sélectionner un type',
      anyVehicle: 'Tout type de véhicule',
      weight: 'Poids (kg)',
      weightPlaceholder: '1000',
      volume: 'Volume (m³)',
      volumePlaceholder: '10.5',
      unitType: "Type d'unité",
      unitTypePlaceholder: 'Sélectionner un type',
      quantity: 'Quantité',
      quantityPlaceholder: 'Ex: 12',
      cargoDescription: 'Description de la marchandise',
      cargoDescriptionPlaceholder: 'Décrivez la nature de votre cargaison...',
      specialInstructions: 'Instructions spéciales',
      specialInstructionsPlaceholder: 'Consignes particulières, contraintes horaires...',
      cargoPhoto: 'Photo de la marchandise (optionnel)',
      cargoPhotoHelper: 'Une image pour illustrer votre marchandise',
    },
    
    unitTypes: {
      palettes: 'Palettes',
      caisses: 'Caisses',
      euroPalettes: 'Euro-palettes',
    },
    
    section3: {
      title: '3. Tarification',
      subtitle: 'Mode de fixation du prix',
      pricingMode: 'Mode de tarification',
      fixedPrice: 'Prix fixe',
      fixedPriceDesc: 'Vous définissez le prix de transport',
      auction: 'Enchères',
      auctionDesc: 'Les transporteurs proposent leurs tarifs',
      proposedPrice: 'Prix proposé (€)',
      proposedPricePlaceholder: '850.00',
    },
    
    section4: {
      title: '4. Visibilité',
      subtitle: 'Publication de la commande',
      marketplaceVisible: 'Rendre visible sur la marketplace',
      marketplaceVisibleDesc: 'Les transporteurs pourront voir et soumettre des offres',
    },
    
    actions: {
      saveDraft: 'Sauvegarder brouillon',
      createOrder: 'Créer la commande',
      creating: 'Création...',
    },
    
    toasts: {
      draftSaved: 'Brouillon sauvegardé !',
      orderCreated: 'Commande créée et publiée !',
      priceRequired: 'Prix proposé requis pour publier la commande',
      error: 'Erreur lors de la création de la commande',
    },
    
    validation: {
      numberTooLong: 'Numéro trop long',
      streetNameRequired: 'Nom de rue requis (min. 3 caractères)',
      streetNameTooLong: 'Nom de rue trop long',
      postalCodeRequired: 'Code postal requis',
      postalCodeTooLong: 'Code postal trop long',
      cityRequired: 'Ville requise',
      cityTooLong: 'Ville trop longue',
      countryRequired: 'Pays requis',
      countryTooLong: 'Pays trop long',
      pickupDateRequired: 'Date de départ requise',
      deliveryDateRequired: 'Date de livraison requise',
      invalidTime: 'Heure invalide (format HH:MM)',
      contactRequired: 'Nom du contact requis',
      contactTooLong: 'Nom trop long',
      phoneRequired: 'Téléphone requis (min. 8 chiffres)',
      phoneTooLong: 'Téléphone trop long',
      detailsTooLong: 'Détails trop longs',
      cargoTitleRequired: 'Titre requis (min. 3 caractères)',
      cargoTitleTooLong: 'Titre trop long',
      vehicleTypeRequired: 'Type de véhicule requis',
      weightRequired: 'Poids requis',
      weightMax: 'Poids maximum 100 000 kg',
      volumeMax: 'Volume maximum 200 m³',
      quantityNegative: 'Le nombre ne peut pas être négatif',
      quantityMax: 'Maximum 100',
      descriptionRequired: 'Description requise (min. 10 caractères)',
      descriptionTooLong: 'Description trop longue',
      instructionsTooLong: 'Instructions trop longues',
      priceRequired: 'Prix requis',
      priceMax: 'Prix maximum 1 000 000€',
    },
  },

  // Rating System
  rating: {
    title: 'Noter cette livraison',
    question: 'Comment s\'est passée cette livraison ?',
    comment: 'Commentaire (optionnel)',
    commentPlaceholder: 'Partagez votre expérience avec ce partenaire...',
    submit: 'Envoyer mon évaluation',
    submitting: 'Envoi en cours...',
    success: 'Merci pour votre évaluation !',
    error: 'Erreur lors de l\'envoi de l\'évaluation',
    alreadyRated: 'Vous avez déjà noté cette commande',
    rateDelivery: 'Noter la livraison',
    rateClient: 'Noter ce client',
    toRate: 'À noter',
    noRatingsYet: 'Aucune évaluation pour le moment',
    
    excellent: 'Excellent ! 🌟',
    veryGood: 'Très bien 👍',
    good: 'Bien ✓',
    fair: 'Passable',
    poor: 'Insuffisant',
    
    companyProfile: {
      title: 'Évaluations',
      average: 'Note moyenne',
      totalReviews: 'avis',
      distribution: 'Répartition des notes',
    },
    
    yourRating: 'Votre évaluation',
    partnerRating: 'Évaluation du partenaire',
  },

  // Toast
  toast: {
    reservationConfirmed: "Réservation confirmée avec succès",
    reservationDeclined: "Réservation refusée",
    error: "Une erreur est survenue",
  },

  // Legal
  legal: {
    termsOfService: {
      title: "Conditions Générales d'Utilisation",
      lastUpdate: "Dernière mise à jour",
      section1: {
        title: "1. Objet",
        content: "Les présentes Conditions Générales d'Utilisation (CGU) définissent les modalités d'utilisation de la plateforme Velox, un service de mise en relation entre expéditeurs et transporteurs. En utilisant notre plateforme, vous acceptez sans réserve les présentes CGU.",
      },
      section2: {
        title: "2. Inscription et Compte Utilisateur",
        content: "L'utilisation de la plateforme nécessite la création d'un compte utilisateur. Vous vous engagez à fournir des informations exactes et à jour, notamment votre numéro SIRET/TVA et vos coordonnées bancaires (IBAN). Vous êtes responsable de la confidentialité de vos identifiants de connexion.",
      },
      section3: {
        title: "3. Services Proposés",
        content: "Velox met en relation des expéditeurs ayant besoin de services de transport avec des transporteurs professionnels. La plateforme facilite la création de commandes, la soumission d'offres, le suivi en temps réel et la gestion de la facturation. Velox agit uniquement comme intermédiaire et n'est pas partie au contrat de transport.",
      },
      section4: {
        title: "4. Obligations des Utilisateurs",
        content: "Les expéditeurs s'engagent à fournir des informations exactes sur leurs marchandises. Les transporteurs s'engagent à disposer des licences et assurances nécessaires pour exercer leur activité. Tous les utilisateurs s'engagent à respecter la législation en vigueur et à ne pas utiliser la plateforme à des fins frauduleuses.",
      },
      section5: {
        title: "5. Tarification et Paiement",
        content: "Les prix sont librement négociés entre expéditeurs et transporteurs. Velox perçoit une commission sur chaque transaction réalisée via la plateforme. Les paiements sont sécurisés et transitent par notre système de paiement intégré. Les factures sont disponibles dans l'espace facturation.",
      },
      section6: {
        title: "6. Responsabilités",
        content: "Velox ne peut être tenu responsable des dommages résultant de l'exécution du contrat de transport entre expéditeur et transporteur. La responsabilité de Velox est limitée à la mise à disposition de la plateforme. En cas de litige, les parties s'engagent à rechercher une solution amiable avant toute action judiciaire.",
      },
    },
    privacyPolicy: {
      title: "Mentions Légales",
      lastUpdate: "Dernière mise à jour",
      section1: {
        title: "1. Éditeur de la Plateforme",
        content: "Velox est édité par [Nom de la société], société par actions simplifiée au capital de [montant] euros, immatriculée au RCS de [ville] sous le numéro [numéro], dont le siège social est situé [adresse complète]. Directeur de la publication : [Nom]. Contact : contact@velox.com",
      },
      section2: {
        title: "2. Hébergement",
        content: "La plateforme Velox est hébergée par Supabase Inc., 970 Toa Payoh North, #07-04, Singapore 318992. Le service utilise une infrastructure cloud sécurisée avec des serveurs situés en Europe (RGPD compliant).",
      },
      section3: {
        title: "3. Protection des Données Personnelles",
        content: "Conformément au RGPD, vous disposez d'un droit d'accès, de rectification et de suppression de vos données personnelles. Les données collectées (nom, email, téléphone, SIRET, IBAN) sont nécessaires au fonctionnement du service et sont conservées de manière sécurisée. Elles ne sont jamais partagées avec des tiers sans votre consentement.",
      },
      section4: {
        title: "4. Cookies",
        content: "La plateforme utilise des cookies techniques essentiels au fonctionnement du service (authentification, préférences de langue). Aucun cookie publicitaire ou de tracking n'est utilisé. Vous pouvez configurer votre navigateur pour refuser les cookies, mais cela peut affecter certaines fonctionnalités.",
      },
      section5: {
        title: "5. Propriété Intellectuelle",
        content: "Tous les éléments de la plateforme Velox (logos, textes, graphismes, logiciels) sont protégés par le droit d'auteur et sont la propriété exclusive de Velox. Toute reproduction, représentation ou exploitation non autorisée est interdite.",
      },
      section6: {
        title: "6. Droit Applicable",
        content: "Les présentes mentions légales sont régies par le droit français. En cas de litige, les tribunaux français seront seuls compétents. Pour toute question relative aux mentions légales, vous pouvez nous contacter à l'adresse : legal@velox.com",
      },
    },
  },
  support: {
    title: 'Support Velox',
    description: 'Contactez notre équipe support',
    callVelox: 'Appeler Velox',
    email: 'Email',
    phone: 'Téléphone',
    adminTitle: 'Coordonnées support Velox',
    adminDescription: "Ces informations sont affichées aux utilisateurs lorsqu'ils contactent le support.",
  },
  supportChat: {
    title: 'Support Velox',
    adminTitle: 'Tickets de support',
    adminNav: 'Support',
    open: 'Ouvrir le tchat',
    yourTickets: 'Vos tickets',
    newTicket: 'Nouveau ticket',
    empty: 'Aucun ticket pour le moment',
    writeMessage: 'Écrire un message…',
    send: 'Envoyer',
    skip: 'Passer cette étape',
    pickOrder: 'Sélectionnez la commande concernée :',
    descPlaceholder: 'Décrivez votre problème ou votre demande…',
    selectTicket: 'Sélectionnez un ticket pour voir la conversation',
    markResolved: 'Marquer résolu',
    close: 'Fermer',
    assignMe: "M'assigner",
    filter: { all: 'Tous les statuts' },
    status: {
      bot: 'Qualification',
      pending_admin: 'En attente',
      open: 'Ouvert',
      resolved: 'Résolu',
      closed: 'Fermé',
    },
    cat: {
      offer: 'Une offre',
      mission: 'Une mission',
      account: 'Mon compte',
      payment: 'Paiement / facturation',
      other: 'Autre',
    },
    bot: {
      greeting: 'Bonjour 👋 Je suis l\'assistant Velox. Je vais vous orienter vers la bonne personne.',
      askCategory: 'À propos de quoi souhaitez-vous nous contacter ?',
      askContext: 'Sur quelle commande porte votre demande ? (vous pouvez aussi passer cette étape)',
      askDescription: 'Décrivez votre demande en quelques mots, l\'équipe vous répondra rapidement.',
      handoff: 'Merci ! Un membre de l\'équipe Velox va prendre le relais et vous répondre dès que possible.',
    },
  },
  adminCreate: {
    navShort: 'Créer compte',
    title: 'Créer un compte',
    subtitle: "Créez une société shipper, transporteur, ou ajoutez un chauffeur à une société existante.",
    tabs: {
      shipper: 'Société Shipper',
      transporter: 'Société Transporteur',
      driver: 'Chauffeur',
      admin: 'Administrateur',
    },
    sections: {
      company: 'Informations de la société',
      ownerInfo: "Propriétaire du compte",
      driverInfo: 'Informations du chauffeur',
      adminInfo: "Informations de l'administrateur",
      attachToTransporter: 'Société transporteur',
      activation: 'Activation du compte',
    },
    fields: {
      foundedDate: "Date d'existence de la société",
      companyName: "Nom de la société",
      companyPhone: 'Téléphone société',
      transporter: 'Société transporteur',
      transporterPlaceholder: 'Sélectionner une société',
      firstName: 'Prénom',
      lastName: 'Nom',
      email: 'Email',
      phone: 'Téléphone',
      password: 'Mot de passe temporaire',
      passwordPlaceholder: 'Au moins 8 caractères',
      passwordHint: "L'utilisateur pourra le modifier après connexion.",
    },
    mode: {
      invite: {
        label: "Envoyer une invitation par email",
        desc: "L'utilisateur reçoit un lien pour définir son mot de passe et activer son compte.",
      },
      direct: {
        label: 'Créer directement avec un mot de passe',
        desc: 'Le compte est immédiatement actif. Communiquez le mot de passe à la personne.',
      },
    },
    submit: {
      invite: "Envoyer l'invitation",
      direct: 'Créer le compte',
    },
    success: {
      invite: 'Invitation envoyée avec succès.',
      direct: 'Compte créé avec succès.',
    },
    errors: {
      missingUser: "Renseignez tous les champs de l'utilisateur.",
      missingCompany: 'Renseignez le nom et téléphone de la société.',
      pickCompany: 'Sélectionnez une société transporteur.',
      shortPassword: 'Le mot de passe doit faire au moins 8 caractères.',
      emailTaken: 'Cette adresse e-mail est déjà utilisée par un compte existant. Aucun compte ni email n\'a été créé.',
      generic: 'Erreur lors de la création du compte.',
    },
  },
  emailTemplates: {
    tab: 'Emails',
    title: "Modèles d'emails",
    description: "Personnalisez les emails envoyés lors de la création de comptes.",
    invitation: "Invitation (activation par l'utilisateur)",
    passwordReset: 'Réinitialisation du mot de passe',
    signupWelcome: "Bienvenue (inscription)",
    emailChange: "Changement d'adresse e-mail",
    directWelcome: 'Bienvenue (création directe)',
    subject: 'Sujet',
    bodyHtml: 'Contenu HTML',
    enabled: 'Email activé',
    enabledHint: "Si désactivé, aucun email ne sera envoyé.",
    bccAdmin: "Copie cachée (BCC) à l'admin",
    bccAdminHint: "Recevoir une copie de chaque email envoyé.",
    variables: 'Variables disponibles',
  },
  adminDocuments: {
    docSearchPlaceholder: 'Rechercher un document (fichier, catégorie, commande, plaque, chauffeur)...',
    categoryAll: 'Toutes les catégories',
    statusAll: 'Tous les statuts',
    resetFilters: 'Réinitialiser',
    noResults: 'Aucun document ne correspond à votre recherche.',
    companiesShown_one: '{{count}} société affichée',
    companiesShown_other: '{{count}} sociétés affichées',
    addedByVelox: 'Ajouté par Velox',
    categories: {
      kyc: 'KYC / identité',
      insurance_license: 'Assurance & licence',
      contract: 'Contrat / commercial',
      registration_card: 'Carte grise',
      inspection: 'Contrôle technique',
      driver_license: 'Permis de conduire',
      loading_photos: 'Photos chargement',
      delivery_photos: 'Photos livraison',
      cmr: 'CMR / bon de livraison',
      other: 'Autre',
    },
    add: {
      button: 'Ajouter un document',
      buttonShort: 'Ajouter',
      title: 'Ajouter un document',
      description: 'Ce document sera rattaché à {{company}} et visible par cette société.',
      scope: 'Rattacher à',
      scopeCompany: "L'entreprise (onboarding)",
      scopeOrder: 'Une commande (fret)',
        scopeVehicle: 'Un véhicule',
        scopeDriver: 'Un chauffeur',
        vehicle: 'Véhicule',
        vehicleSearch: 'Rechercher un véhicule...',
        vehiclePlaceholder: 'Sélectionner un véhicule',
        noVehicles: "Cette société n'a pas encore de véhicule enregistré.",
        noDrivers: "Cette société n'a pas encore de chauffeur enregistré.",
        vehicleRequired: 'Veuillez sélectionner un véhicule.',
        driver: 'Chauffeur',
        driverSearch: 'Rechercher un chauffeur...',
        driverPlaceholder: 'Sélectionner un chauffeur',
        driverRequired: 'Veuillez sélectionner un chauffeur.',
      order: 'Commande',
      orderSearch: 'Rechercher une commande...',
      orderPlaceholder: 'Sélectionner une commande',
      category: 'Catégorie',
      label: 'Libellé',
      labelPlaceholder: "Ex. Attestation d'assurance 2026",
      expiry: "Date d'expiration (optionnelle)",
      notes: 'Note interne (optionnelle)',
      chooseFile: 'Choisir un fichier',
      fileHint: 'Formats acceptés : PDF, JPG, PNG (max 10 Mo)',
      uploading: 'Envoi en cours...',
      submit: 'Ajouter le document',
      success: 'Document ajouté',
      error: "Le document n'a pas pu être ajouté",
      invalidType: 'Format non supporté. Utilisez PDF, JPG ou PNG.',
      tooLarge: 'Fichier trop volumineux (max 10 Mo)',
      fileRequired: 'Veuillez sélectionner un fichier',
      orderRequired: 'Veuillez sélectionner une commande',
      deleteTitle: 'Supprimer ce document ?',
      deleteDescription: '{{name}} sera définitivement supprimé. Cette action est irréversible.',
      deleteSuccess: 'Document supprimé',
      deleteError: "Le document n'a pas pu être supprimé",
    },
    breadcrumb: 'Documents',
    shippers: 'Shippers',
    transporters: 'Transporteurs',
    title: 'Documents utilisateurs',
    subtitle: 'Sélectionnez une société pour consulter ses documents organisés par catégorie.',
    searchPlaceholder: 'Rechercher une société...',
    noCompanies: 'Aucune société {{side}}.',
    sideShipper: 'shipper',
    sideTransporter: 'transporteur',
    usersCount_one: '{{count}} utilisateur',
    usersCount_other: '{{count}} utilisateurs',
    docsCount_one: '{{count}} document',
    docsCount_other: '{{count}} documents',
    expiredCount_one: '{{count}} expiré',
    expiredCount_other: '{{count}} expirés',
    missingCount_one: '{{count}} manquant',
    missingCount_other: '{{count}} manquants',
    complete: 'Complet',
    back: 'Retour',
    sectionOnboarding: 'Onboarding',
    sectionFleet: 'Flotte',
    sectionFreight: 'Freight',
    onboardingTitle: "Documents d'onboarding",
    onboardingDesc: 'KBIS, TVA, RIB, licence de transport, assurance RC, conditions générales…',
    onboardingEmpty: "Aucun document d'onboarding chargé pour cette société.",
    fleetTitle: 'Documents de flotte',
    trucks: 'Camions',
    trailers: 'Remorques',
    drivers: 'Chauffeurs',
    emptyTrucks: 'Aucun camion enregistré.',
    emptyTrailers: 'Aucune remorque enregistrée. (Distinction camion/remorque à venir.)',
    emptyDrivers: 'Aucun chauffeur enregistré.',
    noDocsResource: 'Aucun document associé.',
    freightTitle: 'Documents de freight',
    freightDesc: 'Une entrée par commande : ordre de transport, CMR / POD, douane, litiges, photos.',
    freightEmpty: 'Aucune commande avec documents.',
    orderLabel: 'Commande {{number}}',
    noDocs: 'Aucun document.',
    tableNature: 'Nature',
    tableFile: 'Fichier',
    tableStatus: 'Statut',
    tableSize: 'Taille',
    tableDate: 'Date',
    tableAction: 'Action',
    statusVerified: 'Vérifié',
    statusExpiring: 'Expire bientôt',
    statusExpired: 'Expiré',
    statusUnverified: 'Non vérifié',
    licensePrefix: 'Permis',
    licenseExpires: 'expire',
    licenseNotSet: 'Permis non renseigné',
    openError: "Impossible d'ouvrir le document",
    natureRegistration: 'Carte grise',
    natureInsurance: 'Assurance',
    natureInspection: 'Contrôle technique',
    natureOther: 'Autre',
    natureCargo: 'Photo cargo',
    natureStart: 'Photo départ',
    natureDelivery: 'Photo livraison',
    natureDocument: 'Document',
  },
  footer: {
    tagline: 'La plateforme de transport et de fret qui relie expéditeurs, transporteurs et chauffeurs à travers l\'Europe.',
    legalTitle: 'Informations légales',
    contactTitle: 'Support',
    partnersTitle: 'Nos partenaires',
    copyright: '© 2026 Velox. Tous droits réservés.',
    links: {
      about: 'À propos',
      terms: 'Conditions générales',
      privacy: 'Politique de confidentialité',
      legalNotice: 'Mentions légales',
      cookiePolicy: 'Politique en matière de cookies',
      cookieSettings: 'Paramètres des cookies',
    },
    short: {
      about: 'À propos',
      terms: 'CGU',
      privacy: 'Confidentialité',
      legalNotice: 'Mentions légales',
      cookies: 'Cookies',
      support: 'Support',
    },
  },
  legalNotice: {
    back: 'Retour à l\'accueil',
    title: 'Mentions légales',
    lastUpdated: 'Dernière mise à jour : janvier 2026',
    sections: {
      publisher: {
        title: 'Éditeur du site',
        body: 'Velox\nPlateforme de gestion de transport et de fret.\nContact : support@myvelox.eu\nSite : https://myvelox.eu',
      },
      hosting: {
        title: 'Hébergement',
        body: 'Le site et ses services sont hébergés par des prestataires d\'infrastructure cloud situés dans l\'Union européenne.',
      },
      intellectualProperty: {
        title: 'Propriété intellectuelle',
        body: 'L\'ensemble des contenus présents sur la plateforme (textes, visuels, logos, code) est protégé par le droit de la propriété intellectuelle. Toute reproduction ou réutilisation sans autorisation écrite préalable est interdite.',
      },
      dataProtection: {
        title: 'Protection des données',
        body: 'Les données personnelles sont traitées conformément au RGPD. Pour en savoir plus, consultez notre politique de confidentialité. Vous pouvez exercer vos droits d\'accès, de rectification et de suppression en contactant notre support.',
      },
      contact: {
        title: 'Contact',
        body: 'Pour toute question relative aux présentes mentions légales, contactez notre équipe support depuis l\'application ou par e-mail.',
      },
    },
  },
  cookies: {
    alwaysOn: 'Toujours actifs',
    banner: {
      title: 'Nous respectons votre vie privée',
      description: 'Nous utilisons des cookies strictement nécessaires au fonctionnement de Velox et, avec votre consentement, des cookies fonctionnels et analytiques.',
      readPolicy: 'Lire la politique en matière de cookies',
      customize: 'Personnaliser',
      acceptAll: 'Tout accepter',
      rejectAll: 'Tout refuser',
      save: 'Enregistrer mes choix',
    },
    categories: {
      necessary: {
        title: 'Cookies strictement nécessaires',
        description: 'Indispensables au fonctionnement du site (session, sécurité, mémorisation de vos choix de cookies).',
      },
      functional: {
        title: 'Cookies fonctionnels',
        description: 'Mémorisent vos préférences, comme la langue choisie.',
      },
      analytics: {
        title: 'Cookies analytiques',
        description: 'Nous aident à comprendre l\'utilisation du site (PostHog) afin de l\'améliorer.',
      },
    },
  },
  invite: {
    title: 'Rejoindre Velox',
    subtitle: 'Vous avez été invité à rejoindre',
    subtitleRole: 'en tant que',
    email: 'Email',
    firstName: 'Prénom',
    lastName: 'Nom',
    password: 'Mot de passe',
    passwordPlaceholder: 'Minimum 8 caractères',
    confirmPassword: 'Confirmer le mot de passe',
    confirmPasswordPlaceholder: 'Retapez votre mot de passe',
    creating: 'Création en cours...',
    createAccount: 'Créer mon compte',
    invalidTitle: 'Invitation invalide',
    invalidDescription: 'Cette invitation est invalide, expirée ou a déjà été utilisée. Contactez la personne qui vous a invité.',
    backToLogin: 'Retour à la connexion',
    welcome: 'Bienvenue !',
    accountConfigured: 'Votre compte a bien été configuré.',
    accountReady: 'Compte prêt',
    pleaseSignIn: 'Connectez-vous avec votre nouveau mot de passe.',
    sentInvitations: 'Invitations envoyées',
    statusAccepted: 'Acceptée',
    passwordSet: 'Mot de passe créé',
    emailAlreadyUsed: 'Cette adresse est déjà utilisée par un compte ({{company}} — {{role}}). Aucun email n\'a été envoyé.',
    invitationAlreadyPending: 'Une invitation est déjà en attente pour cette adresse ({{company}}). Aucun email n\'a été envoyé.',
    errors: {
      expired: 'Cette invitation a expiré.',
      alreadyAccepted: 'Cette invitation a déjà été utilisée.',
      invalidToken: 'Lien d\'invitation invalide.',
      weakPassword: 'Le mot de passe doit contenir au moins 8 caractères.',
      passwordMismatch: 'Les mots de passe ne correspondent pas.',
      generic: 'Impossible de finaliser votre inscription. Réessayez ou contactez le support.',
    },
  },
  adminInvitations: {
    actions: 'Actions',
    resend: 'Relancer l\'invitation',
    resendSuccess: 'Invitation relancée',
    resendSuccessDescription: 'Un nouvel email a été envoyé à {{email}}.',
    resendError: 'L\'invitation n\'a pas pu être relancée.',
    delete: 'Supprimer',
    deleteTitle: 'Supprimer cette invitation ?',
    deleteDescription: 'Le lien d\'invitation cessera immédiatement de fonctionner. Cette action est irréversible.',
    deleteSuccess: 'Invitation supprimée',
    deleteError: 'L\'invitation n\'a pas pu être supprimée.',
    searchPlaceholder: 'Rechercher une invitation...',
    refresh: 'Rafraîchir',
    pageInfo: 'Page {{page}} / {{total}} — {{count}} invitation(s)',
    title: 'Invitations envoyées',
    empty: 'Aucune invitation pour le moment.',
    person: 'Personne',
    email: 'Email',
    company: 'Entreprise',
    role: 'Rôle',
    sentAt: 'Envoyée le',
    expiresAt: 'Expire le',
    status: 'Statut',
    statuses: {
      pending: 'En attente',
      accepted: 'Acceptée',
      expired: 'Expirée',
    },
  },
};
